export default "__VITE_ASSET__BR85F$YR__"